// eslint-disable-next-line @typescript-eslint/no-explicit-any
export let OAuthProvider;

(function (OAuthProvider) {
  OAuthProvider["Intuit"] = "intuit";
  OAuthProvider["Google"] = "google";
})(OAuthProvider || (OAuthProvider = {}));

export let KycCompletionStatus;

(function (KycCompletionStatus) {
  KycCompletionStatus["InitialIncomplete"] = "initialIncomplete";
  KycCompletionStatus["Completed"] = "completed";
  KycCompletionStatus["Incomplete"] = "incomplete";
  KycCompletionStatus["CompletedWithFutureRequirements"] = "completedWithFutureRequirements";
})(KycCompletionStatus || (KycCompletionStatus = {}));

export let UserRole;

(function (UserRole) {
  UserRole["Member"] = "member";
  UserRole["Admin"] = "admin";
  UserRole["Owner"] = "owner";
  UserRole["Accountant"] = "accountant";
  UserRole["AnchorAdmin"] = "anchorAdmin";
})(UserRole || (UserRole = {}));